import { Box, Typography } from '@mui/material';
import MultiLineTooltip from '@ui/MultiLineTooltip';
import React from 'react';
import { getDisplayNumber } from '@shared/helpers/display/get-display-number.helper';
import { KineticNumberDisplay } from '@ui/KineticNumberDisplay';

type CompactValueDisplayProps = {
  value: number;
  unit: string;
  icon?: React.ReactNode;
  tooltipTitle: string;
};

/**
 * Displays a compact value with a tooltip
 * Note: the unit MUST be correct for the value. No conversion will be done.
 *
 * @param value - The value to display (will be formatted using getDisplayNumber with notation: 'compact')
 * @param icon - The icon to display
 * @param tooltipTitle - The title of the tooltip
 * @param unit - The unit of the value, will be displayed in the second row of the tooltip. WILL NOT be used for formatting.
 * @returns
 */
export const CompactValueDisplay: React.FC<CompactValueDisplayProps> = ({
  tooltipTitle,
  value,
  icon,
  unit,
}) => {
  return (
    <MultiLineTooltip disableInteractive rows={[tooltipTitle, unit]}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {icon && (
          <Box
            sx={{
              color: 'text.subtle',
            }}
          >
            {icon}
          </Box>
        )}
        <Typography
          sx={{
            fontSize: 10,
          }}
        >
          <KineticNumberDisplay
            value={value}
            format={(displayValue) =>
              getDisplayNumber(displayValue, { notation: 'compact' })
            }
          />
        </Typography>
      </Box>
    </MultiLineTooltip>
  );
};
